// extracted by mini-css-extract-plugin
export default {"button":"BuyRMVControl_button__CNLIJ"};